import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { path, contains, propEq, find } from 'ramda';
import { Tooltip } from 'antd';
import { translate } from 'react-translate-component';
import { withRouter } from 'react-router';

import { worksheetMassStage } from 'constants/routes';
import { openModalWorksheetUnsupported } from 'actions/modalActions';
import { WORKSHEET_DISABLE_STATUSES } from 'constants/worksheet';
import { getUser } from 'actions/asyncActions';

const stateToProps = (state) => ({
    userId: getUser.selectData(state).id,
});

@withRouter
@connect(stateToProps, { openModalWorksheetUnsupported })
export default class WorksheetLink extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        item: PropTypes.object.isRequired,
        openModalWorksheetUnsupported: PropTypes.func,
        userId: PropTypes.number
    };

    openWorksheet = () => {
        const { history, item: { id, firstStageKey, groupNameStatus }, openModalWorksheetUnsupported } = this.props;

        if (contains(groupNameStatus, WORKSHEET_DISABLE_STATUSES)) {
            openModalWorksheetUnsupported();
        } else {
            history.push(worksheetMassStage.stringify({ id, stage: firstStageKey }));
        }
    }

    render () {
        const { item: { participants }, userId } = this.props;
        const isParticipant = !participants || !!find(propEq('id', userId))(participants);

        return isParticipant ? (
            <a onClick={this.openWorksheet}>
                <span>{path(['item', 'posname', '0', 'text'], this.props)}</span>
            </a>
        ) : (
            <Tooltip title={translate('worksheetMass.toolTips.notParticipant')}>
                <span>{path(['item', 'posname', '0', 'text'], this.props)}</span>
            </Tooltip>
        );
    }
}
